<template>
  <div class="app-content pt-3 p-md-3 p-lg-4">
    <div class="container-fluid">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="app-page-title mb-0">Session &amp; Semester Settings</h1>
      </div>

      <div class="app-card shadow-sm mb-4">
        <div class="app-card-body p-4">
          <div v-if="loading" class="text-center my-4">
            <b-spinner variant="primary"></b-spinner>
            <div class="mt-2 text-muted">Loading settings...</div>
          </div>

          <template v-else>
            <div class="row mb-3">
              <div class="col-md-4">
                <b-form-input
                  v-model="filter"
                  placeholder="Search sessions..."
                  debounce="300"
                ></b-form-input>
              </div>
            </div>

            <b-table
              :items="settings"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              responsive
              striped
              hover
              show-empty
            >
              <template #empty>
                <div class="text-center text-muted py-4">No settings found.</div>
              </template>
              <template #cell(index)="data">
                {{ (currentPage - 1) * perPage + data.index + 1 }}
              </template>
              <template #cell(status)="data">
                <b-badge :variant="data.value === 'active' ? 'success' : 'secondary'">
                  {{ data.value || 'inactive' }}
                </b-badge>
              </template>
              <template #cell(created_at)="data">
                {{ formatDate(data.value) }}
              </template>
            </b-table>

            <div class="d-flex justify-content-between align-items-center" v-if="settings.length > perPage">
              <small class="text-muted">{{ settings.length }} sessions total</small>
              <b-pagination
                v-model="currentPage"
                :total-rows="settings.length"
                :per-page="perPage"
                size="sm"
              ></b-pagination>
            </div>

            <div class="mt-4 p-3 bg-light rounded" v-if="activeSetting">
              <h5 class="mb-2">Current Active Session</h5>
              <div class="row">
                <div class="col-md-4">
                  <strong>Session:</strong> {{ activeSetting.session_name }}
                </div>
                <div class="col-md-4">
                  <strong>Semester:</strong> {{ activeSetting.semester_name }}
                </div>
                <div class="col-md-4">
                  <strong>Status:</strong>
                  <b-badge variant="success">Active</b-badge>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      settings: [],
      loading: false,
      filter: "",
      perPage: 15,
      currentPage: 1,
      fields: [
        { key: "index", label: "#", class: "text-center", thStyle: { width: "50px" } },
        { key: "session_name", label: "Session", sortable: true },
        { key: "semester_name", label: "Semester", sortable: true },
        { key: "status", label: "Status", class: "text-center", sortable: true },
        { key: "created_at", label: "Created", sortable: true },
      ],
    };
  },
  computed: {
    activeSetting() {
      return this.settings.find((s) => s.status === "active") || null;
    },
  },
  created() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      this.loading = true;
      axios
        .post("admin/settings")
        .then((res) => {
          this.settings = res.data.settings || [];
        })
        .catch(() => Toast.fire({ icon: "error", title: "Failed to load settings" }))
        .finally(() => (this.loading = false));
    },
    formatDate(val) {
      if (!val) return "N/A";
      return new Date(val).toLocaleDateString("en-NG", {
        year: "numeric", month: "short", day: "numeric",
      });
    },
  },
};
</script>
